import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { requestInterceptorConfig, responseInterceptorConfig, responseErrorConfig, setup } from "@dp/state";
import DPServices from "@dp/services";
import { initi18n } from "@dp/common";
import debounce from "lodash/debounce";
import { getAllRests, getRest, getConceptMenu, getMenuDetail, getAppInit, getSessionDetails, getSessionInit, updateRestaurant, getOrderPickupTimes, setPickupTime, getOrderDetails, getResourceBundles } from "../db";
export var vpnRequestInterceptor = function vpnRequestInterceptor(config) {
  // if (config.url.indexOf("https://stage") >= 0) {
  // config.headers["Authorization"] = "Basic REByZGVudSRlcjokZWN1cmUxMiM=";
  // }
  return config;
};

var grabWindowSize = function grabWindowSize(rootStore) {
  rootStore.winWidth = window.innerWidth;
  rootStore.winHeight = window.innerHeight;
};

export function bootstrapClientSidePage(_x) {
  return _bootstrapClientSidePage.apply(this, arguments);
}

function _bootstrapClientSidePage() {
  _bootstrapClientSidePage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(rootStore) {
    var _rootStore$platformUt, _rootStore$common, _rootStore$common$app;

    var network, __DEV__, globalRequestInterceptor, globalResponseInterceptor, globalErrorInterceptor, _process$env, NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV, NEXT_PUBLIC_REACT_APP_SITE_ID, NEXT_PUBLIC_REACT_APP_DEFAULT_LOCALE, NEXT_PUBLIC_REACT_APP_DEV_ENDPOINT_OVERRIDE, NEXT_PUBLIC_REACT_APP_PRD_ENDPOINT_OVERRIDE, windowResizeListener, _yield$Promise$all, _yield$Promise$all2, resources, conceptCode;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            populateEnv();
            network = rootStore.network;
            setup(network);
            __DEV__ = false;
            globalRequestInterceptor = requestInterceptorConfig;
            globalResponseInterceptor = responseInterceptorConfig;
            globalErrorInterceptor = responseErrorConfig;
            _process$env = process.env, NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV = _process$env.NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV, NEXT_PUBLIC_REACT_APP_SITE_ID = _process$env.NEXT_PUBLIC_REACT_APP_SITE_ID, NEXT_PUBLIC_REACT_APP_DEFAULT_LOCALE = _process$env.NEXT_PUBLIC_REACT_APP_DEFAULT_LOCALE, NEXT_PUBLIC_REACT_APP_DEV_ENDPOINT_OVERRIDE = _process$env.NEXT_PUBLIC_REACT_APP_DEV_ENDPOINT_OVERRIDE, NEXT_PUBLIC_REACT_APP_PRD_ENDPOINT_OVERRIDE = _process$env.NEXT_PUBLIC_REACT_APP_PRD_ENDPOINT_OVERRIDE;

            if (__DEV__) {
              if (NEXT_PUBLIC_REACT_APP_DEV_ENDPOINT_OVERRIDE) {
                DPServices.Config.setAPIPrefix(NEXT_PUBLIC_REACT_APP_DEV_ENDPOINT_OVERRIDE);
              }
            } else {
              if (NEXT_PUBLIC_REACT_APP_PRD_ENDPOINT_OVERRIDE) {
                DPServices.Config.setAPIPrefix(NEXT_PUBLIC_REACT_APP_PRD_ENDPOINT_OVERRIDE);
              }
            }

            DPServices.Config.setEnvironment(NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV);
            DPServices.Config.setCommonQueryParams({
              locale: ((_rootStore$platformUt = rootStore.platformUtil.getHostName()) === null || _rootStore$platformUt === void 0 ? void 0 : _rootStore$platformUt.indexOf(".ca")) !== -1 ? "en_CA" : "en_US"
            });
            DPServices.Config.setCommonProps({
              siteId: NEXT_PUBLIC_REACT_APP_SITE_ID
            });
            DPServices.Config.setCommonHeaders({
              "x-source-channel": "WEB"
            });
            DPServices.Core.registerRequestInterceptor(globalRequestInterceptor, globalErrorInterceptor);
            DPServices.Core.registerResponseInterceptor(globalResponseInterceptor, globalErrorInterceptor);
            grabWindowSize(rootStore);

            if (__DEV__) {
              //Uncomment for local api proxy for development
              DPServices.Core.registerRequestInterceptor( // devServerPageRequestInterceptor,
              vpnRequestInterceptor, function (err) {//NOOP
              });
            }

            windowResizeListener = debounce(function () {
              grabWindowSize(rootStore);
            }, 500);
            window.addEventListener("resize", windowResizeListener);
            rootStore.styleCode = "OG";
            _context2.next = 22;
            return Promise.all([DPServices.Common.getResourceBundles(), rootStore.init()]);

          case 22:
            _yield$Promise$all = _context2.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
            resources = _yield$Promise$all2[0];
            _context2.next = 27;
            return initi18n(resources);

          case 27:
            conceptCode = (_rootStore$common = rootStore.common) === null || _rootStore$common === void 0 ? void 0 : (_rootStore$common$app = _rootStore$common.appAttributes) === null || _rootStore$common$app === void 0 ? void 0 : _rootStore$common$app.currentConceptCode;

            if (conceptCode) {
              rootStore.styleCode = conceptCode;
            }

            return _context2.abrupt("return", rootStore.styleCode);

          case 30:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _bootstrapClientSidePage.apply(this, arguments);
}

function populateEnv() {
  var NEXT_PUBLIC_REACT_APP_PAYPAL_SB_CLIENT_ID = process.env.NEXT_PUBLIC_REACT_APP_PAYPAL_SB_CLIENT_ID;
  var NEXT_PUBLIC_REACT_APP_PAYPAL_PROD_CLIENT_ID = process.env.NEXT_PUBLIC_REACT_APP_PAYPAL_PROD_CLIENT_ID;
  var NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV = process.env.NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV;
  var NEXT_PUBLIC_REACT_APP_CONCEPT_CODE = process.env.NEXT_PUBLIC_REACT_APP_CONCEPT_CODE;
  var NEXT_PUBLIC_REACT_APP_SITE_ID = process.env.NEXT_PUBLIC_REACT_APP_SITE_ID;
  var NEXT_PUBLIC_REACT_APP_DEFAULT_LOCALE = process.env.NEXT_PUBLIC_REACT_APP_DEFAULT_LOCALE;
  var NEXT_PUBLIC_REACT_APP_DEV_ENDPOINT_OVERRIDE = process.env.NEXT_PUBLIC_REACT_APP_DEV_ENDPOINT_OVERRIDE;
  var NEXT_PUBLIC_REACT_APP_ORDER_SESSION_TOKEN_RETRY_COUNT = process.env.NEXT_PUBLIC_REACT_APP_ORDER_SESSION_TOKEN_RETRY_COUNT;
  var NEXT_PUBLIC_REACT_APP_BAMS_API_RETRY_COUNT = process.env.NEXT_PUBLIC_REACT_APP_BAMS_API_RETRY_COUNT;
  var NEXT_PUBLIC_REACT_APP_ORDER_SESSION_TOKEN_FAILURE_IN_REST_PAYMENT_FALLBACK = process.env.NEXT_PUBLIC_REACT_APP_ORDER_SESSION_TOKEN_FAILURE_IN_REST_PAYMENT_FALLBACK;
  var NEXT_PUBLIC_REACT_APP_CC_FORM_PARTIAL_AVS_ENABLED = process.env.NEXT_PUBLIC_REACT_APP_CC_FORM_PARTIAL_AVS_ENABLED;
  var NEXT_PUBLIC_REACT_APP_PERSIST_VER = process.env.NEXT_PUBLIC_REACT_APP_PERSIST_VER;
  var NEXT_PUBLIC_REACT_APP_MIN_APPLE_PAY_VERSION = process.env.NEXT_PUBLIC_REACT_APP_MIN_APPLE_PAY_VERSION;
  var NODE_ENV = "production";
  var vars = {
    NEXT_PUBLIC_REACT_APP_PAYPAL_SB_CLIENT_ID: NEXT_PUBLIC_REACT_APP_PAYPAL_SB_CLIENT_ID,
    NEXT_PUBLIC_REACT_APP_PAYPAL_PROD_CLIENT_ID: NEXT_PUBLIC_REACT_APP_PAYPAL_PROD_CLIENT_ID,
    NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV: NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV,
    NEXT_PUBLIC_REACT_APP_CONCEPT_CODE: NEXT_PUBLIC_REACT_APP_CONCEPT_CODE,
    NEXT_PUBLIC_REACT_APP_SITE_ID: NEXT_PUBLIC_REACT_APP_SITE_ID,
    NEXT_PUBLIC_REACT_APP_DEFAULT_LOCALE: NEXT_PUBLIC_REACT_APP_DEFAULT_LOCALE,
    NEXT_PUBLIC_REACT_APP_DEV_ENDPOINT_OVERRIDE: NEXT_PUBLIC_REACT_APP_DEV_ENDPOINT_OVERRIDE,
    NEXT_PUBLIC_REACT_APP_ORDER_SESSION_TOKEN_RETRY_COUNT: NEXT_PUBLIC_REACT_APP_ORDER_SESSION_TOKEN_RETRY_COUNT,
    NEXT_PUBLIC_REACT_APP_BAMS_API_RETRY_COUNT: NEXT_PUBLIC_REACT_APP_BAMS_API_RETRY_COUNT,
    NEXT_PUBLIC_REACT_APP_ORDER_SESSION_TOKEN_FAILURE_IN_REST_PAYMENT_FALLBACK: NEXT_PUBLIC_REACT_APP_ORDER_SESSION_TOKEN_FAILURE_IN_REST_PAYMENT_FALLBACK,
    NEXT_PUBLIC_REACT_APP_CC_FORM_PARTIAL_AVS_ENABLED: NEXT_PUBLIC_REACT_APP_CC_FORM_PARTIAL_AVS_ENABLED,
    NEXT_PUBLIC_REACT_APP_PERSIST_VER: NEXT_PUBLIC_REACT_APP_PERSIST_VER,
    NEXT_PUBLIC_REACT_APP_MIN_APPLE_PAY_VERSION: NEXT_PUBLIC_REACT_APP_MIN_APPLE_PAY_VERSION,
    NODE_ENV: NODE_ENV
  };
  var existing = process.env;
  process.env = _objectSpread(_objectSpread({}, existing), vars);
}

export var devServerPageRequestInterceptor = function devServerPageRequestInterceptor(requestConfig) {
  var shouldProxy = requestConfig.url.indexOf("/web-api") >= 0;

  if (shouldProxy) {
    var url = requestConfig.url;
    var brand = "LH";
    var path = url.split("/web-api")[1];
    console.log("Intercepting " + path);

    requestConfig.adapter = function (config) {
      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
          var proxyData, allRestsResp, restId, resp, _restId, restDetailResp, menuDetailResp, menuResp, _restId2, _resp, _restId3, _resp2, _restId4, _resp3, _restId5, _resp4, res;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  proxyData = {};

                  if (!(path === "/restaurants")) {
                    _context.next = 8;
                    break;
                  }

                  _context.next = 4;
                  return getAllRests(brand);

                case 4:
                  allRestsResp = _context.sent;
                  proxyData = allRestsResp;
                  _context.next = 93;
                  break;

                case 8:
                  if (!(path.indexOf("/appinit") >= 0)) {
                    _context.next = 14;
                    break;
                  }

                  _context.next = 11;
                  return getAppInit(brand);

                case 11:
                  proxyData = _context.sent;
                  _context.next = 93;
                  break;

                case 14:
                  if (!(path.indexOf("/sessioninit") >= 0)) {
                    _context.next = 20;
                    break;
                  }

                  _context.next = 17;
                  return getSessionInit(brand);

                case 17:
                  proxyData = _context.sent;
                  _context.next = 93;
                  break;

                case 20:
                  if (!(path.indexOf("/session/details") >= 0)) {
                    _context.next = 26;
                    break;
                  }

                  _context.next = 23;
                  return getSessionDetails(brand);

                case 23:
                  proxyData = _context.sent;
                  _context.next = 93;
                  break;

                case 26:
                  if (!(path.indexOf("/restaurant/update") >= 0)) {
                    _context.next = 35;
                    break;
                  }

                  console.log("enter");
                  restId = path.split("/")[2];
                  _context.next = 31;
                  return updateRestaurant(restId, brand);

                case 31:
                  resp = _context.sent;
                  proxyData = resp;
                  _context.next = 93;
                  break;

                case 35:
                  if (!(path.indexOf("restaurant/") >= 0)) {
                    _context.next = 45;
                    break;
                  }

                  _restId = path.split("/")[2];
                  console.log("getRest");
                  _context.next = 40;
                  return getRest(_restId, brand);

                case 40:
                  restDetailResp = _context.sent;
                  console.log("restDetailResp", restDetailResp);
                  proxyData = restDetailResp;
                  _context.next = 93;
                  break;

                case 45:
                  if (!(path.indexOf("menuitem") >= 0)) {
                    _context.next = 52;
                    break;
                  }

                  _context.next = 48;
                  return getMenuDetail("--", brand);

                case 48:
                  menuDetailResp = _context.sent;
                  proxyData = menuDetailResp;
                  _context.next = 93;
                  break;

                case 52:
                  if (!(path.indexOf("/menu") >= 0)) {
                    _context.next = 59;
                    break;
                  }

                  _context.next = 55;
                  return getConceptMenu(brand);

                case 55:
                  menuResp = _context.sent;
                  proxyData = menuResp;
                  _context.next = 93;
                  break;

                case 59:
                  if (!(path.indexOf("/order/pickup/times") >= 0)) {
                    _context.next = 67;
                    break;
                  }

                  _restId2 = path.split("/")[2];
                  _context.next = 63;
                  return getOrderPickupTimes(_restId2, brand);

                case 63:
                  _resp = _context.sent;
                  proxyData = _resp;
                  _context.next = 93;
                  break;

                case 67:
                  if (!(path.indexOf("/ordersettings/setpickuptime") >= 0)) {
                    _context.next = 75;
                    break;
                  }

                  _restId3 = path.split("/")[2];
                  _context.next = 71;
                  return setPickupTime(_restId3, brand);

                case 71:
                  _resp2 = _context.sent;
                  proxyData = _resp2;
                  _context.next = 93;
                  break;

                case 75:
                  if (!(path.indexOf("/order/detailed") >= 0)) {
                    _context.next = 83;
                    break;
                  }

                  _restId4 = path.split("/")[2];
                  _context.next = 79;
                  return getOrderDetails(_restId4, brand);

                case 79:
                  _resp3 = _context.sent;
                  proxyData = _resp3;
                  _context.next = 93;
                  break;

                case 83:
                  if (!(path.indexOf("/i18n/resources") >= 0)) {
                    _context.next = 91;
                    break;
                  }

                  _restId5 = path.split("/")[2];
                  _context.next = 87;
                  return getResourceBundles(_restId5, brand);

                case 87:
                  _resp4 = _context.sent;
                  proxyData = _resp4;
                  _context.next = 93;
                  break;

                case 91:
                  console.log("Url not handled in devServerInterceptor " + path);
                  proxyData = null;

                case 93:
                  if (proxyData) {
                    res = {
                      data: proxyData,
                      status: 200,
                      statusText: "OK",
                      headers: {
                        "content-type": "application/json; charset=utf-8"
                      },
                      config: config,
                      request: {}
                    };
                    resolve(res);
                  } else {
                    reject("Proxy this url as well: " + url);
                  }

                case 94:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x2, _x3) {
          return _ref.apply(this, arguments);
        };
      }());
    };
  }

  return requestConfig;
};